export default "__VITE_ASSET__UaAhbLcg__"